import { Component, OnDestroy } from '@angular/core';
import { Subject, takeWhile } from 'rxjs';
import { DialogService } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';

import { Export, ExportsService } from '@app/core/exports';
import { YesNoDialogComponent } from '@app/shared';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-export-list',
  templateUrl: './export-list.component.html',
  styleUrls: ['./export-list.component.css'],
})
export class ExportListComponent implements OnDestroy {
  public records$: Subject<Export[]>;
  public selectedRecords: Export[];

  private destroyed: boolean;
  private interval: any;
  public apiUrl = environment.apiUrl;

  constructor(
    private service: ExportsService,
    private router: Router,
    private dialogService: DialogService
  ) {
    this.records$ = new Subject();
    this.interval = setInterval(() => {
      this.loadRecords();
    }, 5000);
    this.loadRecords();
  }

  private loadRecords(): void {
    console.log(
      'selectedRecords',
      this.selectedRecords,
      !this.selectedRecords?.length
    );

    if (!this.selectedRecords?.length) {
      this.service
        .getList()
        .pipe(takeWhile(() => !this.destroyed))
        .subscribe((records) => {
          this.records$.next(records);
        });
    }
  }

  public onRowEdit(panel: Export): void {
    this.router.navigate(['/panels', panel.id]);
  }

  public deleteSelected() {
    this.dialogService
      .open(YesNoDialogComponent, {
        height: '300px',
        width: '300px',
        header: 'Eliminar exportaciones',
        data: {
          message:
            '¿Eliminar las exportacion seleccionadas? Esta acción no se puede deshacer.',
        },
      })
      .onClose.pipe(takeWhile(() => !this.destroyed))
      .subscribe((result) => {
        if (result) {
          this.service
            .deleteMany(this.selectedRecords.map((r) => r.id))
            .pipe(takeWhile(() => !this.destroyed))
            .subscribe(() => {
              this.selectedRecords = [];
              this.loadRecords();
            });
        }
      });
  }

  public ngOnDestroy(): void {
    this.destroyed = true;
    clearInterval(this.interval);
  }
}
